module.exports = __webpack_public_path__ + "static/media/6_Connect-Wires-to-Chime-Kit-1.ebaa1976.svg";